import type { Language } from '@/i18n';
import { en } from './en';
import { hu } from './hu';
import { nb } from './nb';
import { sr } from './sr';
import type { Lexicon } from './types';

const LEXICONS: Record<Language, Lexicon> = { hu, sr, en, nb };

export function lexiconFor(lang: Language): Lexicon {
  return LEXICONS[lang];
}

export { fold, toLatin } from './fold';
export type { Command, Lexicon, Token } from './types';
export { DIRECT_MATERIALS, SURFACE_LETTERS } from './types';
